import React, { useEffect, useState } from 'react';
import { TInfoltd } from '../../types';
import Button from '../../components/global/Button';
import useDebounce from '../../hooks/useDebounce';
import { checkedGreen } from '../../assets/images/dashboard-business';
import styles from '../../common/dropdown/dropdown.module.css';
import { ClipLoader } from 'react-spinners';
import { useCacNameCheck } from '../../apis/auth';
import { registerNetcoreActivity } from '../../utils/registerActivity';
import { useAppSelector } from '../../app/hooks';

type TProps = {
  step1: TInfoltd;
  setStep1: React.Dispatch<React.SetStateAction<TInfoltd>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  step: number;
};
const BusinessName = ({ setStep, step1, setStep1, step }: TProps) => {
  const [name1, setName1] = useState<any>({});
  const [name2, setName2] = useState<any>({});
  const [name3, setName3] = useState<any>({});
  const [name4, setName4] = useState<any>({});

  // CHECKS FOR IF
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);
  const [check3, setCheck3] = useState(false);
  const [check4, setCheck4] = useState(false);
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const debouncedFirstBusinessName = useDebounce(step1.firstbusinessName, 500);
  const debouncedSecondtBusinessName = useDebounce(step1.secondbusinessName, 500);
  const debouncedThirdBusinessName = useDebounce(step1.threebusinessName, 500);
  const debouncedFourthBusinessName = useDebounce(step1.fourthbusinessName, 500);
  const displayErrorMsg = (errorText: string, variable: string) => {
    if (submitting && !variable) {
      return <div className='text-[red] text-[11px]'>{errorText}</div>;
    }
  };

  const mutation1 = useCacNameCheck();
  const mutation2 = useCacNameCheck();
  const mutation3 = useCacNameCheck();
  const mutation4 = useCacNameCheck();
  let nameExists: { [key: string]: string } = {};
  const details = useAppSelector((state) => state.auth.loggedInUserDetails);

  const hasDuplicates = () => {
    const array = [
      step1.firstbusinessName?.trim()?.toLowerCase(),
      step1.secondbusinessName?.trim()?.toLowerCase(),
      step1.threebusinessName?.trim()?.toLowerCase(),
      step1.fourthbusinessName?.trim()?.toLowerCase(),
    ];
    const uniqueItems = new Set(array);
    return uniqueItems.size !== array.length;
  };

  const businessNameIsEmpty = () => {
    return (
      !step1.firstbusinessName ||
      !step1.secondbusinessName ||
      !step1.threebusinessName ||
      !step1.fourthbusinessName
    );
  };

  const businessNameNotFree = () => {
    if (mutation1?.isError || mutation2?.isError || mutation3?.isError || mutation4?.isError) {
      return false;
    }
    return !check1 || !check2 || !check3 || !check4;
  };

  const completedSteps: boolean[] = JSON.parse(localStorage.getItem('completed-steps') ?? '[]');
  const updateCompletedSteps = () => {
    completedSteps[step - 1] = true;
    localStorage.setItem('completed-steps', JSON.stringify(completedSteps));
  };
  const handleNameSearch = ({
    setSimilarNames,
    name,
    setCheck,
    mutate,
  }: {
    setSimilarNames: any;
    name: string;
    setCheck: any;
    mutate: any;
  }) => {
    mutate?.mutate(
      { lineOfBusiness: step1.businessSegment, proposedName: name },
      {
        onSuccess: (data: any) => {
          if (Number(data?.data?.complianceScore?.replace('%', '')) >= 55) {
            setCheck(true);
            setSimilarNames([]);
          } else {
            setCheck(false);
            setSimilarNames(data?.data?.similarNames);
            registerNetcoreActivity(
              {
                emailAddress: details?.email,
                firstName: details?.firstName,
                lastName: details?.lastName,
                mobileNumber: details?.phoneNumber,
              },
              'Business registration-business name declined',
            );
          }
        },
      },
    );
  };

  useEffect(() => {
    if (debouncedFirstBusinessName) {
      handleNameSearch({
        setSimilarNames: setName1,
        name: debouncedFirstBusinessName,
        setCheck: setCheck1,
        mutate: mutation1,
      });
    } else {
      setCheck1(false);
      setName1([]);
    }
  }, [debouncedFirstBusinessName]);

  useEffect(() => {
    if (debouncedSecondtBusinessName) {
      handleNameSearch({
        setSimilarNames: setName2,
        name: debouncedSecondtBusinessName,
        setCheck: setCheck2,
        mutate: mutation2,
      });
    } else {
      setCheck2(false);
      setName2([]);
    }
  }, [debouncedSecondtBusinessName]);

  useEffect(() => {
    if (debouncedThirdBusinessName) {
      handleNameSearch({
        setSimilarNames: setName3,
        name: debouncedThirdBusinessName,
        setCheck: setCheck3,
        mutate: mutation3,
      });
    } else {
      setCheck3(false);
      setName3([]);
    }
  }, [debouncedThirdBusinessName]);

  useEffect(() => {
    if (debouncedFourthBusinessName) {
      handleNameSearch({
        setSimilarNames: setName4,
        name: debouncedFourthBusinessName,
        setCheck: setCheck4,
        mutate: mutation4,
      });
    } else {
      setCheck4(false);
      setName4([]);
    }
  }, [debouncedFourthBusinessName]);
  const handleNameAlreadyExists = (name: string, key: string) => {
    const formatedName = name?.trim().toLowerCase();
    if (Object.keys(nameExists).includes(formatedName)) {
      if (nameExists[formatedName] !== key) {
        return (
          <div className='text-[red] text-[11px]'>{`${name} has already been used by you`}</div>
        );
      }
    } else {
      nameExists = { ...nameExists, [formatedName]: key };
    }
    return null;
  };

  return (
    <div className='flex w-full  lg:w-[650px]'>
      <form className=' stepTwo formCont w-full'>
        <div className='w-full'>
          <div className='flex lg:gap-[4%] flex-wrap lg:mb-[30px]'>
            <div className='mb-[27px] w-full lg:w-[48%]'>
              <div className='w-full relative'>
                <label className='flex flex-col relative text-[#212121] '>Business name 1</label>
                <input
                  className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                  value={step1.firstbusinessName}
                  onChange={(e) => {
                    setStep1({ ...step1, firstbusinessName: e.target.value });
                  }}
                />

                {mutation1?.isPending && (
                  <ClipLoader
                    color={'#F8B400'}
                    loading={mutation1?.isPending}
                    size={20}
                    className='absolute right-[10px] h-[20px] top-[50%]'
                  />
                )}
                {check1 &&
                  !handleNameAlreadyExists(step1.firstbusinessName, 'Name1') &&
                  !mutation1?.isPending && (
                    <img
                      src={checkedGreen}
                      alt=''
                      className='absolute right-[10px] h-[20px] top-[50%]'
                    />
                  )}

                {name1?.length > 0 && (
                  <div className={styles.dropdownMenu_businessName}>
                    <div className='text-[red] text-xs font-[500] h-[40px] flex items-center'>
                      THESE SIMILAR NAME(S) ALREADY EXIST, PLEASE USE ANOTHER NAME
                    </div>
                    <hr className='w-[90%]' />
                    {name1?.map((option: any, i: number) => (
                      <div key={i} className={styles.dropdownItem_businessName}>
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {displayErrorMsg('Business name 1 cannot be empty', step1.firstbusinessName)}
              {handleNameAlreadyExists(step1.firstbusinessName, 'Name1')}
            </div>
            <div className='mb-[27px] w-full lg:w-[48%] relative'>
              <div className='w-full relative'>
                <label className='flex flex-col relative text-[#212121] '>Business name 2</label>
                <input
                  className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                  value={step1.secondbusinessName}
                  onChange={(e) => {
                    setStep1({ ...step1, secondbusinessName: e.target.value });
                  }}
                />

                {mutation2?.isPending && (
                  <ClipLoader
                    color={'#F8B400'}
                    loading={mutation2?.isPending}
                    size={20}
                    className='absolute right-[10px] h-[20px] top-[50%]'
                  />
                )}

                {check2 &&
                  !handleNameAlreadyExists(step1.secondbusinessName, 'Name2') &&
                  !mutation2?.isPending && (
                    <img
                      src={checkedGreen}
                      alt=''
                      className='absolute right-[10px] h-[20px] top-[50%]'
                    />
                  )}
                {name2?.length > 0 && (
                  <div className={styles.dropdownMenu_businessName}>
                    <div className='text-[red] text-xs font-[500] h-[40px] flex items-center'>
                      THESE SIMILAR NAME(S) ALREADY EXIST, PLEASE USE ANOTHER NAME
                    </div>
                    <hr className='w-[90%]' />
                    {name2?.map((option: any, i: number) => (
                      <div key={i} className={styles.dropdownItem_businessName}>
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {displayErrorMsg('Business name 2 cannot be empty', step1.secondbusinessName)}
              {handleNameAlreadyExists(step1.secondbusinessName, 'Name2')}
            </div>
          </div>
          <div className='flex lg:gap-[4%] flex-wrap'>
            <div className='mb-[27px] w-full lg:w-[48%] relative'>
              <div className='w-full relative'>
                <label className='flex flex-col relative text-[#212121] '>Business name 3</label>
                <input
                  className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                  value={step1.threebusinessName}
                  onChange={(e) => {
                    setStep1({ ...step1, threebusinessName: e.target.value });
                  }}
                />
                {mutation3?.isPending && (
                  <ClipLoader
                    color={'#F8B400'}
                    loading={mutation3?.isPending}
                    size={20}
                    className='absolute right-[10px] h-[20px] top-[50%]'
                  />
                )}
                {check3 &&
                  !handleNameAlreadyExists(step1.threebusinessName, 'Name3') &&
                  !mutation3?.isPending && (
                    <img
                      src={checkedGreen}
                      alt=''
                      className='absolute right-[10px] h-[20px] top-[50%]'
                    />
                  )}
                {name3?.length > 0 && (
                  <div className={styles.dropdownMenu_businessName}>
                    <div className='text-[red] text-xs font-[500] h-[40px] flex items-center'>
                      THESE SIMILAR NAME(S) ALREADY EXIST, PLEASE USE ANOTHER NAME
                    </div>
                    <hr className='w-[90%]' />
                    {name3?.map((option: any, i: number) => (
                      <div key={i} className={styles.dropdownItem_businessName}>
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {displayErrorMsg('Business name 3 cannot be empty', step1.threebusinessName)}
              {handleNameAlreadyExists(step1.threebusinessName, 'Name3')}
            </div>
            <div className='mb-[27px] w-full lg:w-[48%] relative'>
              <div className='w-full relative'>
                <label className='flex flex-col relative text-[#212121] '>Business name 4</label>
                <input
                  className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                  value={step1.fourthbusinessName}
                  onChange={(e) => {
                    setStep1({ ...step1, fourthbusinessName: e.target.value });
                  }}
                />
                {mutation4?.isPending && (
                  <ClipLoader
                    color={'#F8B400'}
                    loading={mutation4?.isPending}
                    size={20}
                    className='absolute right-[10px] h-[20px] top-[50%]'
                  />
                )}
                {check4 &&
                  !handleNameAlreadyExists(step1.fourthbusinessName, 'Name4') &&
                  !mutation4?.isPending && (
                    <img
                      src={checkedGreen}
                      alt=''
                      className='absolute right-[10px] h-[20px] top-[50%]'
                    />
                  )}
                {name4?.length > 0 && (
                  <div className={styles.dropdownMenu_businessName}>
                    <div className='text-[red] text-xs font-[500] h-[40px] flex items-center'>
                      THESE SIMILAR NAME(S) ALREADY EXIST, PLEASE USE ANOTHER NAME
                    </div>
                    <hr className='w-[90%]' />
                    {name4?.map((option: any, i: number) => (
                      <div key={i} className={styles.dropdownItem_businessName}>
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {displayErrorMsg('Business name 4 cannot be empty', step1.fourthbusinessName)}
              {handleNameAlreadyExists(step1.fourthbusinessName, 'Name4')}
            </div>
          </div>
          <div className='flex justify-between  mt-[40px] mb-7 md:mb-0 items-center md:mt-[105px]'>
            <Button
              className='md:px-5 px-2 !py-[10px] text-[11px] !bg-[#768396] text-white border-[0px] rounded-none '
              size='sm'
              underline={false}
              theme='secondary'
              onClick={() => {
                setStep((currPage: any) => currPage - 1);
              }}
            >
              PREVIOUS
            </Button>
            <Button
              theme='primary'
              className='px-3 py-[10px] w-[150px] md:min-w-[150px] text-[11px] inline-block '
              size='sm'
              underline={false}
              onClick={() => {
                if (!businessNameIsEmpty() && !hasDuplicates() && !businessNameNotFree()) {
                  setStep((currPage: any) => currPage + 1);
                  updateCompletedSteps();
                }
                setSubmitting(true);
              }}
            >
              SAVE AND CONTINUE
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default BusinessName;
